var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLegalcyreport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V18C0 18.5304 0.210714 19.0391 0.585786 19.4142C0.960859 19.7893 1.46957 20 2 20H9C8.59 19.75 8.2 19.44 7.86 19.1C5.22 16.67 5.05 12.56 7.5 9.92C9.69 7.5 13.33 7.13 16 9V6L10 0ZM9 7V1.5L14.5 7H9ZM16.31 16.9C17.64 14.79 17 12 14.91 10.68C12.8 9.35 10 10 8.69 12.08C7.35 14.19 8 16.97 10.09 18.3C11.55 19.23 13.41 19.23 14.88 18.32L18 21.39L19.39 20L16.31 16.9ZM12.5 17C11.837 17 11.2011 16.7366 10.7322 16.2678C10.2634 15.7989 10 15.163 10 14.5C10 13.837 10.2634 13.2011 10.7322 12.7322C11.2011 12.2634 11.837 12 12.5 12C13.163 12 13.7989 12.2634 14.2678 12.7322C14.7366 13.2011 15 13.837 15 14.5C15 15.163 14.7366 15.7989 14.2678 16.2678C13.7989 16.7366 13.163 17 12.5 17Z",
    fill: "#BFBFBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalcyreport);
export default __webpack_public_path__ + "static/media/legalcyreport.46a271b3ad3dfa2eb7ea5bf1cbb7b471.svg";
export { ForwardRef as ReactComponent };